const identityAccountActionType = Object.freeze({
  verifyDocumentation: 'verify_documentation',
  documentationRequired: 'documentation_required',
  identityPending: 'identity_pending',
});

export default identityAccountActionType;
